// Lib
import { createAction } from 'redux-actions';

export const GetAccountFeed = createAction('GET_ACCOUNT_FEED');
export const SetFeed = createAction('SET_FEED');
export const ErrorFeed = createAction('ERROR_FEED');
export const ClearFeed = createAction('CLEAR_FEED');
// export const GetPartnersFeed = createAction('GET_PARTNERS_FEED');
